"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _table = _interopRequireDefault(require("./table"));

var _head = _interopRequireDefault(require("./head"));

exports.TableHead = _head.default;

var _headCell = _interopRequireDefault(require("./head-cell"));

exports.TableHeadCell = _headCell.default;

var _body = _interopRequireDefault(require("./body"));

exports.TableBody = _body.default;

var _row = _interopRequireDefault(require("./row"));

exports.TableRow = _row.default;

var _cell = _interopRequireDefault(require("./cell"));

exports.TableCell = _cell.default;

var _footer = _interopRequireDefault(require("./footer"));

exports.TableFooter = _footer.default;
_table.default.Head = _head.default;
_table.default.HeadCell = _headCell.default;
_table.default.Body = _body.default;
_table.default.Row = _row.default;
_table.default.Cell = _cell.default;
_table.default.Footer = _footer.default;
var _default = _table.default;
exports.default = _default;